function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_316",
  "data-name": "Group 316"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_10",
  "data-name": "Ellipse 10",
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#eeeff3"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "image_black_24dp",
  transform: "translate(11.857 10.81)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_94",
  "data-name": "Path 94",
  d: "M0,0H26.167V26.167H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_95",
  "data-name": "Path 95",
  d: "M22.625,20.445V5.181A2.187,2.187,0,0,0,20.445,3H5.181A2.187,2.187,0,0,0,3,5.181V20.445a2.187,2.187,0,0,0,2.181,2.181H20.445A2.187,2.187,0,0,0,22.625,20.445ZM9.433,14.971l2.29,2.758,3.38-4.35a.547.547,0,0,1,.872.011l3.827,5.1a.545.545,0,0,1-.436.872H6.293a.543.543,0,0,1-.425-.883l2.715-3.489A.538.538,0,0,1,9.433,14.971Z",
  transform: "translate(0.271 0.271)",
  fill: "#00cd98"
}));

var SvgImageInsideCircle = function SvgImageInsideCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2115",
    "data-name": "Group 2115",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImageInsideCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image-inside-circle.16fbf020.svg";
export { ForwardRef as ReactComponent };